import React from 'react';
import { Home, MapPin, Clock } from 'lucide-react';
export function ShippingSection() {
  return <section className="bg-[#0d0d0d] py-[70px] px-5" id="envios" data-id="element-330">
      <div className="max-w-[1100px] mx-auto" data-id="element-331">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white" data-id="element-332">
          Envíos & Pick Up
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-333">
          Simple, rápido y al mejor precio de Montevideo
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10" data-id="element-334">
          <div className="flex flex-col items-center bg-dark-600 border border-dark-400 rounded-md p-[30px_25px] text-center" data-id="element-335">
            <Home className="w-10 h-10 text-alphaGold mb-[15px]" data-id="element-336" />
            <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] text-white mb-2.5" data-id="element-337">
              Envío a Domicilio
            </h3>
            <span className="text-alphaGold text-[1.4rem] font-black block my-2.5" data-id="element-338">
              Desde $190 UY
            </span>
            <p className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-339">
              Costo varía según tu zona en Montevideo. Lo calculamos al
              confirmar tu pedido por WhatsApp.
            </p>
          </div>

          <div className="flex flex-col items-center bg-dark-600 border border-dark-400 rounded-md p-[30px_25px] text-center" data-id="element-340">
            <MapPin className="w-10 h-10 text-alphaGold mb-[15px]" data-id="element-341" />
            <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] text-white mb-2.5" data-id="element-342">
              Pick Up
            </h3>
            <span className="text-alphaGold text-[1.4rem] font-black block my-2.5" data-id="element-343">
              ¡Sin costo!
            </span>
            <p className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-344">
              Vení a buscarlo directamente a{' '}
              <strong className="text-white" data-id="element-345">Malvín, Montevideo</strong>. Te
              esperamos de Lun a Sáb.
            </p>
          </div>

          <div className="flex flex-col items-center bg-dark-600 border border-dark-400 rounded-md p-[30px_25px] text-center" data-id="element-346">
            <Clock className="w-10 h-10 text-alphaGold mb-[15px]" data-id="element-347" />
            <h3 className="text-[1rem] font-extrabold uppercase tracking-[1px] text-white mb-2.5" data-id="element-348">
              Horario de Atención
            </h3>
            <span className="text-alphaGold text-[1rem] font-black block my-2.5" data-id="element-349">
              Lun — Sáb
            </span>
            <p className="text-[#888] text-[0.9rem] leading-[1.6]" data-id="element-350">
              De <strong className="text-white" data-id="element-351">10:00 a 18:00 horas</strong>.
              <br data-id="element-352" />
              Domingo: cerrados.
            </p>
          </div>
        </div>
      </div>
    </section>;
}